module.exports = __webpack_public_path__ + "img/aParty_121223_E.0e659663.jpg";